module.exports = __webpack_public_path__ + "img/financial.46e9d097.jpg";